import { render, staticRenderFns } from "./a-label.vue?vue&type=template&id=759dfac3&"
import script from "./a-label.vue?vue&type=script&lang=js&"
export * from "./a-label.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports